/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const organizationOlapReportExportRetrieveQueryFromDtSchema = z.string().optional().describe("Дата начала периода в формате ISO (YYYY-MM-DDTHH:MM:SS)");

export const organizationOlapReportExportRetrievePathOrganizationIdSchema = z.uuid();

export const organizationOlapReportExportRetrieveQueryToDtSchema = z.string().optional().describe("Дата окончания периода в формате ISO (YYYY-MM-DDTHH:MM:SS)");

export const organizationOlapReportExportRetrieveStatus200Schema = z.any();

export const organizationOlapReportExportRetrieveResponseSchema = organizationOlapReportExportRetrieveStatus200Schema;
